import React, { useContext, useEffect, useState } from "react";
import { API, Storage, graphqlOperation } from "aws-amplify";
import Edit from "../../assets/hugeicons_mail-edit-01.svg"; // Import the SVG image
import Send from "../../assets/iconoir_send.svg"; // Import the SVG image
import close from "../../assets/carbon_close-outline.svg"; // Import the SVG image
import { SpotContext } from "../../context/SpotContext";
import { createSpotCandidateStatus, updateSpotJD, updateSpotResume } from "../../graphql/mutations";

import {sendEmailAPIforCompany} from "../Utils/SendmailForCompany";

function SpotPlusSendMailPopup({ onClose, onTargetActive }) {

  const [companyProfile, setCompanyProfile] = useState(null);

  // target candidate code start

  const [mailsendCandidates, setMailsendCandidates] = useState([]);

  // target candidate code end

  // Store code start

  const {
    spotprocessSelectedJD,
    spotprocessSelectedResume,
    spotprocessAiJDSlcandidates,
    spotprocessAiResumeSlCandidates,
    spotprocessAiJDSselectedCandidates,
    spotprocessAiResumeselectedCandidates,
    setFinalSelectedCandidate,

    setSpotprocessCompanyJDList,
    setSpotprocessSelectedJDID,
    // setSpotprocessSelectedJD,
    setSpotprocessSelectedResume,
    setSpotprocessAiJDSlcandidates,
    setSpotprocessAiResumeSlCandidates,
    setSpotprocessAiJDSselectedCandidates,
    setSpotprocessAiResumeselectedCandidates,
    setLoadingPrepareAIData,
    setLoadingPrepareAIResumeData,

  } = useContext(SpotContext);

  // Store code end

  useEffect(() => {

    const storedProfile = localStorage.getItem('CompanyProfile');


    if (storedProfile) {
      try {
        // Parse the JSON string into an object
        const profileObject = JSON.parse(storedProfile);
        setCompanyProfile(profileObject);
      } catch (error) {
        // console.error('Error parsing CompanyProfile from localStorage:', error);
      }
    }

    // text formated intial phase code start

    const htmlContent = `
    <html>
      <body>
        ${content
        .split("\n")
        .map((line) => {
          if (line.trim() === "") return ""; // Skip empty lines
          if (line.startsWith("-")) return `<li>${line.substring(1).trim()}</li>`; // Bullet points
          return `<p>${line.trim()}</p>`; // Wrap other lines in <p>
        })
        .join("\n")}
      </body>
    </html>
    `;

    setFormattedHTMLContent(htmlContent.trim());

    // test formated intial phase code end

  }, [])

  const [isEditable, setIsEditable] = useState(false);
  // Define your email template with placeholders

  const emailTemplate = `Subject: Congratulations! You’ve Been Shortlisted for the [Position Name]

Dear [Candidate's Name],

I hope this email finds you well.

We are pleased to inform you that you have been shortlisted for the next stage of the interview process for the [Position Name] role at [Company Name].

After reviewing your application and qualifications, we believe that your skills and experiences align well with what we are looking for in this role.

Interview Details:

Date: January 10, 2025
Interview Type: Virtual
Location/Platform: Zoom link: https://zoom.us/j/123456789
The interview will primarily focus on your knowledge and expertise in artificial intelligence, as well as how your experiences can contribute to TechCorp. It will also provide an opportunity for you to share your thoughts on how AI can shape the future at TechCorp.

Please confirm your availability for the interview by replying to this email at your earliest convenience.

Should you have any questions or need any additional information prior to the interview, feel free to reach out to us.

We are excited to learn more about you and discuss how you can be a great addition to our team.

Best regards,

[Your Name]
`;


  // Set the email template as the initial content
  const [content, setContent] = useState(emailTemplate);

  const handleEditClick = () => {
    setIsEditable(true);
  };


  const [formattedHTMLContent, setFormattedHTMLContent] = useState(content);

  const handleSaveClick = () => {
    setIsEditable(false);
    // When saving, convert plain text into HTML format
    // const htmlContent = convertToHTML(content);
    // setContent(htmlContent);


    const htmlContent = `
<html>
  <body>
    ${content
        .split("\n")
        .map((line) => {
          if (line.trim() === "") return ""; // Skip empty lines
          if (line.startsWith("-")) return `<li>${line.substring(1).trim()}</li>`; // Bullet points
          return `<p>${line.trim()}</p>`; // Wrap other lines in <p>
        })
        .join("\n")}
  </body>
</html>
    `;

    setFormattedHTMLContent(htmlContent.trim());

  };


  const [candidates, setCandidates] = useState(spotprocessAiResumeselectedCandidates)

  // Mock API function to send emails
  const sendEmailAPI = async (candidate, subject, body) => {

    // const res = await sendEmailAPIforCompany(candidate.email,subject,body,spotprocessSelectedJD.companyEmail);

    // console.log("res", res);

    // const isEmailSent = res.message === "Email sent successfully"; // This will return a boolean (true/false)

    const input = {
      companyEmail: spotprocessSelectedJD.companyEmail, // Only email
      spotResumeID: spotprocessSelectedResume.id,
      spotJdID: spotprocessSelectedJD.id,
      candidateEmail: candidate.email,
      roundStatus: "firstRound",
      // isEmailsend: isEmailSent,
      candidateFrom: "Resume",
      selectionFlag: ""
    };


    const response = await API.graphql(graphqlOperation(createSpotCandidateStatus, { input }));

console.log("eeeeeeeeeeeee",response)

    // creating shortlisted candidate list code start

    setMailsendCandidates((prevObjects) => [...prevObjects, candidate]);
    setFinalSelectedCandidate((prevObjects) => [...prevObjects, candidate]);

    // creating shortlisted candidate list code end

    // update spot and resume candidate for filter and selected code start

    const updatespotJD = async () => {


      const selectedCandidateforSpot = JSON.stringify(spotprocessAiJDSselectedCandidates)
      const filterCandidateforSpot = JSON.stringify(spotprocessAiJDSlcandidates)


      const input = {
        // companyEmail: companyEmail,
        id: spotprocessSelectedJD.id,
        selectedCandidate: selectedCandidateforSpot,
        filterCandidate: filterCandidateforSpot,
        spotResumeID:spotprocessSelectedResume.id,
      };
      const responseJD = await API.graphql(graphqlOperation(updateSpotJD, {
        input
      }));

      console.log(responseJD)

    }

    updatespotJD()

    const updateResume = async () => {

      const filterCandidateforResume = JSON.stringify(spotprocessAiResumeSlCandidates)
      const selectedCandidateforResume = JSON.stringify(spotprocessAiResumeselectedCandidates)


      const input = {
        // companyEmail: companyEmail,
        id: spotprocessSelectedResume.id,
        selectedCandidate: selectedCandidateforResume,
        filterCandidate: filterCandidateforResume
      };
      const responseResume = await API.graphql(graphqlOperation(updateSpotResume, {
        input
      }));

      console.log(responseResume)

    }

    updateResume()

    // update spot and resume candidate for filter and selected code end


    onTargetActive()

    const clearData = () => {

      setSpotprocessCompanyJDList([]);
      setSpotprocessSelectedJDID("");
      // setSpotprocessSelectedJD({});
      setSpotprocessSelectedResume({});
      setSpotprocessAiJDSlcandidates([]);
      setSpotprocessAiResumeSlCandidates([]);
      setSpotprocessAiJDSselectedCandidates([]);
      setSpotprocessAiResumeselectedCandidates([]);
      setLoadingPrepareAIData(false);
      setLoadingPrepareAIResumeData(false);
      localStorage.removeItem('RecentJDIdAfterJDupload');

    }

    clearData()

  };

  const handleSendMailClick = async () => {

    if (
      !spotprocessSelectedJD || typeof spotprocessSelectedJD !== 'object' ||
      !spotprocessSelectedResume || typeof spotprocessSelectedResume !== 'object' ||
      !spotprocessAiJDSlcandidates || !Array.isArray(spotprocessAiJDSlcandidates) || spotprocessAiJDSlcandidates.length === 0 ||
      !spotprocessAiResumeSlCandidates || !Array.isArray(spotprocessAiResumeSlCandidates) || spotprocessAiResumeSlCandidates.length === 0 ||
      !spotprocessAiJDSselectedCandidates || !Array.isArray(spotprocessAiJDSselectedCandidates) || spotprocessAiJDSselectedCandidates.length === 0 ||
      !spotprocessAiResumeselectedCandidates || !Array.isArray(spotprocessAiResumeselectedCandidates) || spotprocessAiResumeselectedCandidates.length === 0
    ) {
      alert("Please complete the 'SPOT' process first before proceeding with sending emails."); // Alert the user
      return; // Exit the function
    }


    const subject = `Congratulations! You’ve Been Shortlisted for the ${spotprocessSelectedJD.jdName}`;

    for (const candidate of candidates) {
      const personalizedContent = formattedHTMLContent
        // .replace("[Candidate's Name]", candidate.name)
        // .replace("[Position Name]", spotprocessSelectedJD.jdName) // Example
        // .replace("[Company Name]", companyProfile.companyName) // Example
        // .replace("[Insert Date]", "January 10, 2025") // Example
        // .replace("[Virtual/In-person]", "Virtual") // Example
        // .replace("[Your Name]", companyProfile.companyName) // Example
        // .replace(
        //   "[Insert Platform Link or Physical Address]",
        //   "Zoom link: https://zoom.us/j/123456789" // Example
        // );

        .replace(/\[Candidate's Name\]/g, candidate.name)
        .replace(/\[Position Name\]/g, spotprocessSelectedJD.jdName) // Ensure this is being replaced
        .replace(/\[Company Name\]/g, companyProfile.companyName)
        .replace(/\[Insert Date\]/g, "January 10, 2025")
        .replace(/\[Virtual\/In-person\]/g, "Virtual")
        .replace(/\[Your Name\]/g, companyProfile.companyName)
        .replace(
          /\[Insert Platform Link or Physical Address\]/g,
          "Zoom link: https://zoom.us/j/123456789"
        );

      console.log("uuuuuuuuuuuuu", personalizedContent);


      await sendEmailAPI(candidate, subject, personalizedContent);
    }

    alert("Emails have been sent successfully!");
    // onClose();
  };



  //  sending Email code end

  console.log("spotprocessSelectedJD", spotprocessSelectedJD.jdName)

  return (
    <div style={styles.container}>
      <div style={styles.canvas}>
        <button onClick={onClose} >
          <img src={close} />
        </button>
        <div style={styles.editButtoncontainer}>
          <img onClick={handleEditClick} src={Edit} />

          <img onClick={handleSendMailClick} src={Send} />
        </div>
        <textarea
          style={{ ...styles.textarea, display: isEditable ? "block" : "none" }}
          value={content}
          onChange={(e) => setContent(e.target.value)}
          readOnly={!isEditable}
        />

        {/* <p
          style={{
            // ...styles.textContent,
            ...styles.textarea,
            display: !isEditable ? "block" : "none",
          }}
        >
           {content} 
        </p> */}

        <p
          style={{
            ...styles.textarea,
            display: !isEditable ? "block" : "none",
          }}
          dangerouslySetInnerHTML={{
            // __html: content, // Render content as text
            __html: formattedHTMLContent, // Render content as text
          }}
        />

        <div style={styles.actionButtonContainer}>
          {/* Always show the Send Mail button */}
          {!isEditable && (
            <button style={styles.actionButton}
              //  onClick={handleSendMailClick}
              onClick={handleSendMailClick}
            >
              Send Mail
            </button>
          )}

          {isEditable && (
            <button style={styles.actionButton} onClick={handleSaveClick}>
              Save
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    // justifyContent: "center",
    // height: "100vh",
    height: "54vh",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    zIndex: "12",
    width: "100%",
  },
  canvas: {
    position: "relative",
    width: "80%",
    // maxWidth: "600px",
    // minHeight: "70vh",
    height: "70vh",
    padding: "20px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    background: "#ddc8ff",
    display: "grid",
    // marginTop: "8rem",
    overflowY: "scroll"
  },
  textarea: {
    width: "100%",
    minHeight: "100vh",
    fontSize: "16px",
    lineHeight: "1.5",
    padding: "10px",
    border: "none",
    outline: "none",
    resize: "none",
    fontFamily: "inherit",
    color: "#000",
    borderRadius: "8px",
  },
  textContent: {
    width: "100%",
    minHeight: "40vh",
    fontSize: "16px",
    lineHeight: "1.5",
    color: "#333",
    padding: "3% 1%",
  },
  editButton: {
    position: "absolute",
    top: "10px",
    right: "10px",
    background: "transparent",
    border: "none",
    fontSize: "18px",
    cursor: "pointer",
  },
  actionButton: {
    // position: "absolute",
    bottom: "10px",
    left: "10px",
    padding: "8px 16px",
    fontSize: "14px",
    color: "#fff",
    background:
      "linear-gradient(180deg, rgb(102, 126, 234) 0%, rgb(136, 89, 184) 100%)",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    display: "grid",
  },
  editButtoncontainer: {
    display: "flex",
    border: "1px solid #243642",
    background: "#ffffffad",
    width: "fit-content",
    height: "38px",
    padding: "4px 8px",
    gap: "16px",
    borderRadius: "4px",
    justifySelf: "end",
  },
  actionButtonContainer: {
    display: "flex",
    alignItems: "end",
    justifyContent: "end",
  },
};
export default SpotPlusSendMailPopup;
